import { MutableRefObject } from 'react';
import { GetCarouselEventPropType } from '../types/propTypes';

export const getDotsPadding = (isMobile: boolean, isTablet: boolean, dotsPaddingTop: number | undefined): number => {
  const getDeviceTypeBasedOnTablet = isTablet ? 'tablet' : 'desktop';
  const deviceType: string = isMobile ? 'mobile' : getDeviceTypeBasedOnTablet;
  const defaultPaddings: { [key: string]: number } = { mobile: 16, tablet: 32, desktop: 48 };
  return dotsPaddingTop ?? (defaultPaddings[deviceType as keyof typeof defaultPaddings] as number);
};

export const getCarouselContainerConfig = (ref: MutableRefObject<HTMLDivElement | undefined>) => {
  let clientWidth = 0,
    scrollWidth = 0,
    scrollLeft = 0;
  if (ref.current) {
    clientWidth = ref.current.clientWidth;
    scrollWidth = ref.current.scrollWidth;
    scrollLeft = ref.current.scrollLeft;
  }
  return {
    clientWidth,
    scrollWidth,
    scrollLeft,
  };
};

export const dotsToDisplayArr = (dotsToDisplay: number) =>
  Number.isFinite(dotsToDisplay) ? new Array(dotsToDisplay) : [];

export const getCarouselEvent = ({
  pauseOnMouseOver,
  removeInterval,
  resumeInterval,
  isAutoScrollEnable,
}: GetCarouselEventPropType) =>
  pauseOnMouseOver && isAutoScrollEnable
    ? {
        onFocus: () => removeInterval(),
        onMouseEnter: () => removeInterval(),
        onBlur: () => resumeInterval(),
        onMouseLeave: () => resumeInterval(),
      }
    : {};

export const checkIsValueDefined = (value?: number) => value ?? 0;
export const checkIsValueZero = (value?: number) => (value ? value : 1);

export const customRound = (number: number): number => {
  const decimalPart = Number((number - Math.floor(number)).toFixed(2));
  let res: number;
  if (decimalPart <= 0) {
    res = Math.floor(number);
  } else {
    res = Math.ceil(number);
  }
  return res;
};
